import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import {
  ContentCopy as CopyIcon,
  Check as CheckIcon,
} from '@mui/icons-material';

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <IconButton size='small' onClick={handleCopy} sx={{ ml: 1, p: 0.5 }}>
      {copied ? (
        <CheckIcon
          fontSize='inherit'
          color='success'
          sx={{ fontSize: '1rem' }}
        />
      ) : (
        <CopyIcon fontSize='inherit' sx={{ fontSize: '1rem' }} />
      )}
    </IconButton>
  );
};

export default CopyButton;
